import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Placeholder } from './pages/Placeholder';
import { Login } from './pages/Login';
import { AuthCallback } from './pages/AuthCallback';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './hooks/useAuth';
import { ConfigProvider } from './hooks/useConfig';
import { MenuProvider } from './hooks/useMenu';
import { CategoryPage } from './pages/CategoryPage';
import { UserCategoryPage } from './pages/UserCategoryPage';
import { ConfigurationPage } from './pages/ConfigurationPage';
import SysEdit from './pages/SysEdit';
import SysTableEdit from './pages/SysTableEdit';
import { Preferences } from './pages/Preferences';
import { Version } from './pages/Version';
import { Groups } from './pages/Groups';
import { Profile } from './pages/Profile';
import { Soci } from './pages/Soci';
import { Logout } from './pages/Logout';
import Persone from './pages/Persone';
import DettaglioPersona from './pages/DettaglioPersona';
import { WorkspaceHub } from './pages/WorkspaceHub';
import { ImportComuniCap } from './pages/ImportComuniCap';
import { Toaster } from 'sonner';
import { PopupCloser } from './components/PopupCloser';

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <PopupCloser />
      <Routes>
        {/* Rotta di callback isolata dai provider principali per evitare che il popup "diventi" l'app */}
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        {/* Tutte le altre rotte sono avvolte dai provider */}
        <Route element={
      <AuthProvider>
        <MenuProvider>
          <ConfigProvider>
            <Outlet />
          </ConfigProvider>
        </MenuProvider>
      </AuthProvider>
        }>
          <Route path="/login" element={<Login />} />
          
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/user" replace />} />
              
              <Route path="logout" element={<Logout />} />
              <Route path="io" element={<Navigate to="/user/profilo" replace />} />
              
              <Route path="user">
                <Route index element={<UserCategoryPage />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profilo" element={<Profile />} />
                <Route path="profilo/:id" element={<Profile />} />
                <Route path="soci" element={<Soci />} />
                <Route path="soci/:id" element={<Soci />} />
                <Route path="versione" element={<Version />} />
                <Route path="ruoli" element={<Groups />} />
                <Route path="preferenze" element={<Preferences />} />
                <Route path="workspace" element={<WorkspaceHub />} />
              </Route>

              {/* Contabilità */}
              <Route path="contabilita">
                <Route index element={<CategoryPage />} />
                <Route path="*" element={<Placeholder />} />
              </Route>
            
              {/* Segreteria */}
              <Route path="segreteria">
                <Route index element={<CategoryPage />} />
                <Route path="anagrafica" element={<Outlet />}>
                  <Route index element={<CategoryPage />} />
                  <Route path="dashboard" element={<CategoryPage />} />
                  <Route path="aziende" element={<Placeholder />} />
                  <Route path="enti" element={<Placeholder />} />
                  <Route path="persone" element={<Persone />} />
                  <Route path="persone/:id" element={<DettaglioPersona />} />
                  <Route path="professionisti" element={<Placeholder />} />
                  <Route path="simpatizzanti" element={<Placeholder />} />
                  <Route path="sindaci" element={<Placeholder />} />
                  <Route path="soci" element={<Soci />} />
                  <Route path="soci/:id" element={<Soci />} />
                  <Route path="*" element={<Placeholder />} />
                </Route>
                
                {/* Router alias for old/different variants if needed, or just let the main route handle it */}
                <Route path="anagrafiche/*" element={<Navigate to="/segreteria/anagrafica" replace />} />
                
                <Route path="allievi" element={<Placeholder />} />
                <Route path="automezzi" element={<Placeholder />} />
                <Route path="caccia" element={<Placeholder />} />
                <Route path="convenzioni" element={<Placeholder />} />
                <Route path="corsi" element={<Placeholder />} />
                <Route path="pesca" element={<Placeholder />} />
                <Route path="rubrica" element={<Placeholder />} />
                <Route path="servizi" element={<Placeholder />} />
                <Route path="tabelle" element={<Placeholder />} />
                <Route path="*" element={<Placeholder />} />
              </Route>

              {/* Fatturazione */}
              <Route path="fatturazione">
                <Route index element={<CategoryPage />} />
                <Route path="*" element={<Placeholder />} />
              </Route>
              
              {/* Consiglio Direttivo */}
              <Route path="consiglio-direttivo">
                <Route index element={<CategoryPage />} />
                <Route path="*" element={<Placeholder />} />
              </Route>
              
              {/* Zona Bologna */}
              <Route path="zona-bologna">
                <Route index element={<CategoryPage />} />
                <Route path="*" element={<Placeholder />} />
              </Route>
              
              {/* Sistema */}
              <Route path="sistema">
                <Route index element={<CategoryPage />} />
                <Route path="configurazione" element={<ConfigurationPage />} />
                <Route path="import-comuni" element={<ImportComuniCap />} />
                <Route path="sysedit" element={<SysEdit />} />
                <Route path="sysedit/:tableName" element={<SysTableEdit />} />
                <Route path="*" element={<Placeholder />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/user" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
